// import { defineAsyncComponent } from 'vue';
// const CciSection = defineAsyncComponent(() => import(/* webpackChunkName: 'Section' */ './CciSection.vue'))
import CciSection from './CciSection.vue'
import { mapGetters } from 'vuex'
import Swiper from 'swiper/bundle'

export default {
  data () {
    return { 
      scroller: null,
      sectionMountedCounter: 0,
      resizeObserver: null
     }
  },
  mounted () {
    // this.initializeScroller()

    this.resizeObserver = new ResizeObserver(this.didResize)
    // get webreader-app div
    const webreaderApp = document.getElementById('webreader-app')
    // observe the webreader-app div
    this.resizeObserver.observe(webreaderApp)
  },
  computed: {
    ...mapGetters({
      sections: 'getSections',
      currentSection: 'getCurrentSection',
      pages: 'getPages',
      showArticleModal: 'getShowArticleModal',
      showIssueOverview: 'getShowIssueOverview',    
    })
  },
  watch: {
    currentSection: function (newValue) {
      if (this.scroller !== null && !this.isSectionElemInView(newValue.id)) {
        const index = this.sections.indexOf(newValue)
        this.scroller.slideTo(index)
      }
    },
    '$route': function (newValue, oldValue) {
      if (oldValue.name === 'articles' || oldValue.name === 'articles-mobile') {
        this.initializeScroller()
        let section = this.getSectionFromPageParam(newValue.params.pageNr)
        this.$store.commit('setCurrentSection', section)
      }
    }
  },
  methods: {
    initializeScroller() {
      // this.$nextTick( function () {

        if (this.scroller !== null) {
          this.scroller.destroy()
          this.scroller = null
        }

        this.scroller = new Swiper ('.section-swiper-container', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          freeMode: true,
          freeModeSticky: true,
          slideClass: 'section-swiper-slide',
          wrapperClass: 'section-swiper-wrapper',
          grapCursor: true,
          mousewheel: true,
          navigation: {
            nextEl: '.section-nav-next-button',
            prevEl: '.section-nav-prev-button'
          },
          a11y: {
            enabled: false
          }
        })

        var index = this.sections.indexOf(this.currentSection)
        this.scroller.slideTo(index)

        this.didResize()
      // })
    },
    getSectionFromPageParam(pageNr) {
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].secondPage !== null) {
          if (this.pages[i].secondPage.pageNumber === pageNr || this.pages[i].firstPage.pageNumber === pageNr) {
            return this.pages[i].secondPage.sections[0]
          }
        }
        if (this.pages[i].firstPage.pageNumber === pageNr) {
          return this.pages[i].firstPage.sections[0]
        }
      }
    },
    didResize () {
      if (this.$route.name !== 'pages') {
        return
      }

      const sectionsBarWidth = document.getElementById('sections-bar').clientWidth

      const swiperElems = document.getElementsByClassName('section-swiper-slide')
      let swiperElemsWidth = 0

      for (let i = 0; i < swiperElems.length; i++) {
        swiperElemsWidth += swiperElems[i].clientWidth
      }

      const sectionPrev = document.getElementById('section-nav-prev-button')
      const sectionNext = document.getElementById('section-nav-next-button')
      const swiperContainer = document.getElementById('section-swiper-container')
      if (swiperElemsWidth < sectionsBarWidth && swiperElems.length !== 0) {
        // section-nav-buttons are not needed when all sections fit in the sections-bar
        // hide section-nav-buttons
        sectionPrev.style.display = 'none'
        sectionNext.style.display = 'none'
        // document.getElementById('section-nav').style.display = 'none'
        swiperContainer.style.padding = '0'
      } else {
        sectionPrev.style.display = 'block'
        sectionNext.style.display = 'block'

        // document.getElementById('section-nav').style.display = 'block'
        swiperContainer.style.paddingLeft = '32px'
        swiperContainer.style.paddingRight = '32px'
      }

      // set prev and next button and icon height to the same as the swiper container
      let swiperContainerHeight = Math.round(swiperContainer.getBoundingClientRect().height)
      // subtract section-contaner border-bottom width
      // const borderBottomWidth = getComputedStyle(document.getElementById('sections-bar')).borderBottomWidth
      // if (borderBottomWidth !== '') {
      //   swiperContainerHeight -= parseFloat(borderBottomWidth.split('px')[0])
      // }

      sectionPrev.style.height = swiperContainerHeight + 'px'
      sectionNext.style.height = swiperContainerHeight + 'px'
      document.getElementById('section-nav-prev-icon').style.height = swiperContainerHeight +'px'
      document.getElementById('section-nav-next-icon').style.height = swiperContainerHeight +'px'
    },
    isSectionElemInView (sectionId) {
      for (let key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.section.id === sectionId) {
            let elem = ref.$el
            let bounding = elem.getBoundingClientRect()
            const appWidth = document.getElementById('webreader-app').clientWidth
            const appHeight = document.getElementById('webreader-app').clientHeight
            return (
              bounding.top >= 0 &&
              bounding.left >= 0 &&
              bounding.bottom <= appHeight &&
              bounding.right <= appWidth
            )
          }
        }
      }
    },
    skipSectionBar() {
      // Skip sections bar, focus on first interactive layer on the page
      const interactiveLayers = document.getElementsByClassName("layer");
      // Focus on first interactive layer that is not aria-disabled (visible on page)
      if (interactiveLayers.length > 0) {
        for (let i = 0; i < interactiveLayers.length; i++) {
          if (!interactiveLayers[i].getAttribute("aria-disabled")) {
            interactiveLayers[i].focus();
            break;
          }
        }
      } else {
        // If no interactive layers, focus on next page button
        const nextPageButton = document.getElementById("page-nav-next-button");
        if (nextPageButton !== null) {
          nextPageButton.focus();
        }
      }
    },
    itemInFocus(index) {
      if (this.isSectionElemInView(this.sections[index].id)) {
        return
      }
      // slide to the item in focus
      this.scroller.slideTo(index)
    },
    sectionMounted () {
      this.sectionMountedCounter++
      if (this.sectionMountedCounter === this.sections.length) {
        this.initializeScroller()
      }
    }
  },
  components: {
    CciSection
  },
  beforeUnmount () {
    if (this.resizeObserver !== null) {
      this.resizeObserver.disconnect()
    }
    if (this.scroller !== null) {
      this.scroller.destroy()
      this.scroller = null
    }
  }
}
